module.exports = __webpack_public_path__ + "static/media/1009.64bea567.jpg";